/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PdfSourceDocument
 */
export interface PdfSourceDocument {
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  slug: string;
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  downloadFilename: string;
  /**
   *
   * @type {string}
   * @memberof PdfSourceDocument
   */
  thumbnailUrl?: string | null;
}

/**
 * Check if a given object implements the PdfSourceDocument interface.
 */
export function instanceOfPdfSourceDocument(
  value: object,
): value is PdfSourceDocument {
  if (!("slug" in value) || value["slug"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("downloadFilename" in value) || value["downloadFilename"] === undefined)
    return false;
  return true;
}

export function PdfSourceDocumentFromJSON(json: any): PdfSourceDocument {
  return PdfSourceDocumentFromJSONTyped(json, false);
}

export function PdfSourceDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PdfSourceDocument {
  if (json == null) {
    return json;
  }
  return {
    slug: json["slug"],
    title: json["title"],
    description: json["description"] == null ? undefined : json["description"],
    category: json["category"] == null ? undefined : json["category"],
    downloadFilename: json["downloadFilename"],
    thumbnailUrl:
      json["thumbnailUrl"] == null ? undefined : json["thumbnailUrl"],
  };
}

export function PdfSourceDocumentToJSON(json: any): PdfSourceDocument {
  return PdfSourceDocumentToJSONTyped(json, false);
}

export function PdfSourceDocumentToJSONTyped(
  value?: PdfSourceDocument | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    slug: value["slug"],
    title: value["title"],
    description: value["description"],
    category: value["category"],
    downloadFilename: value["downloadFilename"],
    thumbnailUrl: value["thumbnailUrl"],
  };
}
